module.exports = __webpack_public_path__ + "img/L_8D.9afc6273.png";